import {
  useInfluencerProfileEstimatedAudienceQuery,
  useInfluencerYoutubeAnalyticsAudienceQuery,
  YoutubeAnalyticsAudienceRegionPayload,
  SocialAccountType
} from '@anytag/graphql';
import { AnalyticsYoutubeDashboardAudienceTemplate } from '@anytag/shared-organisms';
import { InfluencerSelectedAccountInfo } from '../../types';

export interface InfluencerAnalyticsYoutubeProfileAudienceProps {
  socialAccount: InfluencerSelectedAccountInfo;
}

export const InfluencerAnalyticsYoutubeProfileAudience = ({
  socialAccount
}: InfluencerAnalyticsYoutubeProfileAudienceProps) => {
  const { data, loading } = useInfluencerYoutubeAnalyticsAudienceQuery({
    fetchPolicy: 'no-cache',
    variables: { socialAccountId: socialAccount.id }
  });
  const { data: estimatedData, loading: estimatedLoading } = useInfluencerProfileEstimatedAudienceQuery({
    variables: {
      socialAccountId: socialAccount.id,
      socialAccountType: SocialAccountType.YOUTUBE
    }
  });

  return (
    <AnalyticsYoutubeDashboardAudienceTemplate
      loading={loading || estimatedLoading}
      data={{
        // Mixed data details: https://anymindgroup.atlassian.net/browse/AT-7636
        ...data?.influencerYoutubeAnalyticsAudience,
        regionRate:
          estimatedData?.influencerProfileEstimatedAudience?.location?.regions?.map<YoutubeAnalyticsAudienceRegionPayload>(
            ({ regionName, rate }) => ({ rate, name: regionName })
          )
      }}
    />
  );
};
